import { isEmpty } from 'lodash';

export default function isOptionUpdated(currentPropObject, nextPropObject) {
  if (isEmpty(currentPropObject) || isEmpty(nextPropObject)) {
    return false;
  }

  return nextPropObject && nextPropObject.id !== currentPropObject.id;
}
